import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardService } from "./guards/auth-guard.service";
import { DataResolverService } from "./resolvers/data-resolver.service";
import { RemoteComponent } from "./layout/remote/remote.component";
import { LandingPageComponent } from "./layout/remote/landing-page/landing-page.component";
import { MapPageComponent } from './layout/remote/map-page/map-page.component';
import { SiteDetailComponent } from './layout/remote/site-detail/site-detail.component';
import { UserGuard } from './layout/remote/guards/user.guard';
import { BuyPageComponent } from './layout/remote/buy-page/buy-page.component';
import { ProfilePageComponent } from './layout/remote/profile-page/profile-page.component';
import { PriceListComponent } from './layout/remote/price-list/price-list.component';
import { AboutPageComponent } from './layout/remote/about-page/about-page.component';
import { SearchResultsComponent } from './layout/remote/search-results/search-results.component';
import { JoinMeetingComponent } from './layout/virtualTour/join-meeting/join-meeting.component';
import { MeetingRoomComponent } from './layout/virtualTour/meeting-room/meeting-room.component';

let currentRoutes: Routes = [];
const routes: Routes = [
    {
        path: '',
        component: AdminComponent,
        resolve: {items: DataResolverService},
        data: {
            domain: ''
        },
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./theme/dashboard/default.module').then(m => m.DefaultModule),
                canActivate: [AuthGuardService]
            },
            {
                path: 'screens',
                loadChildren: () => import('./theme/screens/screens.module').then(m => m.ScreensModule),
                canActivate: [AuthGuardService]
            },
            {
                path: 'partners',
                loadChildren: () => import('./theme/partners/partners.module').then(m => m.PartnersModule)
            },
            {
                path: 'sites',
                loadChildren: () => import('./theme/sites/sites.module').then(m => m.SitesModule)
            },
            /*{
                path: 'navigation',
                loadChildren: () => import('./theme/navigation/navigation.module').then(m => m.NavigationModule)
            },
            {
                path: 'widget',
                loadChildren: () => import('./theme/widget/widget.module').then(m => m.WidgetModule)
            },
            {
                path: 'basic',
                loadChildren: () => import('./theme/ui-elements/basic/basic.module').then(m => m.BasicModule)
            },
            {
                path: 'advance',
                loadChildren: () => import('./theme/ui-elements/advance/advance.module').then(m => m.AdvanceModule)
            },
            {
                path: 'animations',
                loadChildren: () => import('./theme/ui-elements/animation/animation.module').then(m => m.AnimationModule)
            },
            {
                path: 'forms',
                loadChildren: () => import('./theme/forms/forms.module').then(m => m.FormsModule)
            },
            {
                path: 'bootstrap-table',
                loadChildren: () => import('./theme/table/bootstrap-table/bootstrap-table.module').then(m => m.BootstrapTableModule)
            },
            {
                path: 'data-table',
                loadChildren: () => import('./theme/table/data-table/data-table.module').then(m => m.DataTableModule)
            },
            {
                path: 'maintenance/error',
                loadChildren: () => import('./theme/maintenance/error/error.module').then(m => m.ErrorModule)
            },
            {
                path: 'maintenance/coming-soon',
                loadChildren: () => import('./theme/maintenance/coming-soon/coming-soon.module').then(m => m.ComingSoonModule)
            },
            {
                path: 'user',
                loadChildren: () => import('./theme/user/user.module').then(m => m.UserModule)
            },
            {
                path: 'task',
                loadChildren: () => import('./theme/task/task.module').then(m => m.TaskModule)
            },
            {
                path: 'invoice',
                loadChildren: () => import('./theme/extension/invoice/invoice.module').then(m => m.InvoiceModule)
            },
            {
                path: 'file-upload-ui',
                loadChildren: () => import('./theme/extension/file-upload-ui/file-upload-ui.module').then(m => m.FileUploadUiModule)
            },
            {
                path: 'charts',
                loadChildren: () => import('./theme/chart/chart.module').then(m => m.ChartModule)
            },
            {
                path: 'map',
                loadChildren: () => import('./theme/map/map.module').then(m => m.MapModule)
            },
            {
                path: 'simple-page',
                loadChildren: () => import('./theme/simple-page/simple-page.module').then(m => m.SimplePageModule)
            }*/
        ]
    },
    {
        path: '',
        component: AuthComponent,
        data: {
            domain: ''
        },
        children: [
            {
                path: 'auth',
                loadChildren: () => import('./theme/auth/auth.module').then(m => m.AuthModule)
            },
            {
                path: 'maintenance/offline-ui',
                loadChildren: () => import('./theme/maintenance/offline-ui/offline-ui.module').then(m => m.OfflineUiModule)
            }
        ]
    },
    {
        path: 'remote',
        component: RemoteComponent,
        data: {
            domain: ''
        },
    },
    {
        path: 'remote/:lang',
        component: RemoteComponent,
        canActivate: [UserGuard],
        data: {
            domain: ''
        },
        children: [
            {
                path: '',
                redirectTo: 'landing',
                pathMatch: 'full',
            },
            {
                path: 'landing',
                component: LandingPageComponent
            },
            {
                path: 'map',
                component: MapPageComponent
            },
            {
                path: 'site/:seotitle',
                component: SiteDetailComponent
            },
            {
                path: 'buy',
                canActivate: [AuthGuardService],
                component: BuyPageComponent
            },
            {
                path: 'profile',
                canActivate: [AuthGuardService],
                component: ProfilePageComponent
            },
            {
                path: 'profile/:tab',
                canActivate: [AuthGuardService],
                component: ProfilePageComponent
            },
            {
                path: 'price-list',
                component: PriceListComponent
            },
            {
                path: 'about-us',
                component: AboutPageComponent
            },
            {
                path: 'results',
                component: SearchResultsComponent
            },
            {
                path: 'join-a-tour',
                component: JoinMeetingComponent
            },
            {
                path: 'join-a-tour/:code',
                component: JoinMeetingComponent
            },
            {
                path: 'meeting-room',
                component: MeetingRoomComponent
            },
            {
                path: 'meeting-room/:code',
                component: MeetingRoomComponent
            }
        ]
    }
];

const currentSubDomain = window.location.hostname
    .replace('www.','')
    .replace('stage.','')
    .split('.')[0];
const mappedRoutes = routes.map((route) => {
    route['data']['domain'] = currentSubDomain;
    return route;
});
switch (currentSubDomain) {
    case "culturevr":
        let remote = mappedRoutes[2];
        remote.path = '';
        let remoteMultiLang = mappedRoutes[3];
        remoteMultiLang.path=':lang'
        currentRoutes = [remote,remoteMultiLang];
        break;
    case "b2b":
    case "cms":
        let cmsAndB2b = [mappedRoutes[0], mappedRoutes[1]];
        currentRoutes = cmsAndB2b;
        break;
    default:
        currentRoutes = mappedRoutes;
}

@NgModule({
    imports: [RouterModule.forRoot(currentRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
